import { useScene } from '../../state/scene.js';
import { IconButton } from '../ui/controls.js';
import { Icon } from '../ui/icons.js';
import { openParticleEditor } from './open.js';
import { PlaybackBar } from './PlaybackBar.js';
import { particleTarget, useParticlePreview } from './preview-store.js';
import './particles.css';

/**
 * Scene view overlay while a particle system is selected (Unity's "Particle
 * Effect" overlay): the same playback controls as the Particle Editor,
 * acting on the Scene view's preview, plus the playback time and count.
 */
export function ParticleEffectOverlay() {
  // Re-render on selection / document / lock changes.
  useScene((s) => s.selection);
  useScene((s) => s.doc);
  const locked = useParticlePreview((s) => s.locked);
  const report = useParticlePreview((s) => s.reports.scene);
  const target = particleTarget(locked);
  if (!target) return null;
  return (
    <section className="scene-overlay pe-overlay" aria-label="Particle Effect">
      <header className="pe-overlay-head">
        <Icon name="particles" size={12} />
        <span>Particle Effect</span>
        <span className="pe-overlay-count mono">{report?.particles ?? 0} particles</span>
        <IconButton icon="panelRight" title="Open Particle Editor" size={12} onClick={() => openParticleEditor(target)} />
      </header>
      <PlaybackBar source="scene" compact />
    </section>
  );
}
